package com.partejar.app.feature.home.presentation

import com.partejar.app.feature.home.data.HomeDashboardData
import com.partejar.app.feature.home.data.HomeDateTime

object HomeUiStateFactory {
    fun create(data: HomeDashboardData): HomeUiState {
        if (
            data.attentionItems.isEmpty() &&
            data.upcomingPregnancies.isEmpty() &&
            data.todayAppointments.isEmpty()
        ) {
            return HomeUiState.Empty
        }

        return HomeUiState.Content(
            userName = data.userName,
            greeting = resolveGreeting(data.dateTime.hour, data.userName),
            dateLabel = formatDate(data.dateTime),
            attentionItems = data.attentionItems.map {
                HomeAttentionItemUi(it.id, it.summary, it.quantity, it.level, it.type)
            },
            upcomingPregnancies = data.upcomingPregnancies
                .sortedBy { it.daysUntilDueDate }
                .take(MAX_UPCOMING_PREGNANCIES)
                .map {
                    HomePregnancyUi(
                        id = it.id,
                        name = it.name,
                        babyName = it.babyName ?: "Nome não informado",
                        gestationalWeeks = it.gestationalWeeks,
                        gestationalDays = it.gestationalDays,
                        dueDate = it.dueDate,
                        responsible = it.responsible,
                        actionRequired = it.actionRequired
                    )
                },
            todayAppointments = data.todayAppointments
                .sortedBy { it.minutesFromMidnight }
                .map { HomeAppointmentUi(it.id, it.time, it.type, it.relatedPerson) }
        )
    }

    fun resolveGreeting(hour: Int, userName: String): HomeGreeting {
        require(hour in 0..23) { "Hour must be between 0 and 23" }
        val period = when (hour) {
            in 5..11 -> HomeGreetingPeriod.MORNING
            in 12..17 -> HomeGreetingPeriod.AFTERNOON
            else -> HomeGreetingPeriod.NIGHT
        }
        val salutation = when (period) {
            HomeGreetingPeriod.MORNING -> "Bom dia"
            HomeGreetingPeriod.AFTERNOON -> "Boa tarde"
            HomeGreetingPeriod.NIGHT -> "Boa noite"
        }
        return HomeGreeting(period, "$salutation, $userName")
    }

    fun formatDate(dateTime: HomeDateTime): String {
        val weekday = WEEKDAYS.getOrElse(dateTime.dayOfWeek - 1) { "" }
        val month = MONTHS.getOrElse(dateTime.month - 1) { "" }
        return "$weekday, ${dateTime.dayOfMonth} de $month"
    }

    private const val MAX_UPCOMING_PREGNANCIES = 3
    private val WEEKDAYS = listOf(
        "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira",
        "Sexta-feira", "Sábado", "Domingo"
    )
    private val MONTHS = listOf(
        "janeiro", "fevereiro", "março", "abril", "maio", "junho",
        "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"
    )
}
